import {createContext} from 'react'

const ConfiguracionContext = createContext()

export default ConfiguracionContext